/* Different Drips — 3-chain bundle builder (sections/dd-bundle.liquid) */
(function () {
  'use strict';
  var SIZE = 3;
  var STORE_KEY = 'dd_bundle_v1';

  function money(cents) {
    var d = cents / 100;
    return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2));
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function init(root) {
    var price = parseInt(root.dataset.price, 10) || 9900;
    var prefix = root.dataset.prefix || '';
    var after = root.dataset.after || 'cart';
    var cartUrl = root.dataset.cartUrl || '/cart';
    var rootUrl = root.dataset.root || '/';
    var bundleName = root.dataset.label || '3 Chains for $99';

    var cards = {};
    var slots = [];
    var variantIndex = {};

    var $ = function (sel, el) { return (el || root).querySelector(sel); };
    var $$ = function (sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); };

    var toastEl = $('[data-ddb-toast]');
    var toastTimer;
    function toast(msg) {
      if (!toastEl) return;
      toastEl.textContent = msg;
      toastEl.classList.add('is-on');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
    }

    /* ---------- cards ---------- */
    $$('[data-ddb-card]').forEach(function (el) {
      var data;
      try { data = JSON.parse($('[data-ddb-data]', el).textContent); } catch (e) { return; }
      var card = {
        el: el, data: data, color: null, length: null,
        img: $('.ddb-card__media img', el),
        colorBtns: $$('[data-ddb-color]', el),
        lenBtns: $$('[data-ddb-length]', el)
      };
      data.variants.forEach(function (v) { variantIndex[v.id] = { card: card, v: v }; });
      cards[data.block] = card;

      // defaults: first color, preferred length (else first available)
      var c0 = card.colorBtns[0];
      card.color = c0 ? c0.dataset.ddbColor : '';
      var lDef = card.lenBtns.filter(function (b) { return b.dataset.default === '1'; })[0] || card.lenBtns[0];
      card.length = lDef ? lDef.dataset.ddbLength : '';

      card.colorBtns.forEach(function (b) {
        b.addEventListener('click', function () { card.color = b.dataset.ddbColor; renderCard(card); });
      });
      card.lenBtns.forEach(function (b) {
        b.addEventListener('click', function () { if (!b.disabled) { card.length = b.dataset.ddbLength; renderCard(card); } });
      });
      $('[data-ddb-add]', el).addEventListener('click', function () { addFromCard(card); });
      var zoomBtn = $('[data-ddb-zoom]', el);
      if (zoomBtn) zoomBtn.addEventListener('click', function () { openLb(card); });
      renderCard(card);
    });

    function currentVariant(card) {
      return card.data.variants.filter(function (v) {
        return (!card.colorBtns.length || v.c === card.color) && (!card.lenBtns.length || v.l === card.length);
      })[0];
    }
    function labelFor(btns, val) {
      var b = btns.filter(function (x) { return (x.dataset.ddbColor || x.dataset.ddbLength) === val; })[0];
      return b ? b.dataset.label : val;
    }

    function renderCard(card) {
      card.colorBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.ddbColor === card.color ? 'true' : 'false'); });
      // lengths: disable ones not available in this color
      card.lenBtns.forEach(function (b) {
        var ok = card.data.variants.some(function (v) {
          return v.l === b.dataset.ddbLength && (!card.colorBtns.length || v.c === card.color) && v.a;
        });
        b.disabled = !ok;
        b.setAttribute('aria-pressed', b.dataset.ddbLength === card.length ? 'true' : 'false');
      });
      var v = currentVariant(card);
      if (v && !v.a) {
        var alt = card.data.variants.filter(function (x) { return x.c === card.color && x.a; })[0];
        if (alt) { card.length = alt.l; return renderCard(card); }
      }
      var cl = $('[data-ddb-color-label]', card.el);
      if (cl) cl.textContent = labelFor(card.colorBtns, card.color);
      var ll = $('[data-ddb-length-label]', card.el);
      if (ll) ll.textContent = labelFor(card.lenBtns, card.length);
      var val = $('[data-ddb-value]', card.el);
      if (val) val.textContent = v ? money(v.p) : '';
      if (v && card.img && v.img && card.img.getAttribute('data-src-now') !== v.img) {
        card.img.removeAttribute('srcset');
        card.img.src = v.img;
        card.img.setAttribute('data-src-now', v.img);
      }
      updateAddBtn(card);
    }

    function updateAddBtn(card) {
      var btn = $('[data-ddb-add]', card.el);
      var txt = $('[data-ddb-add-text]', card.el);
      var v = currentVariant(card);
      var full = slots.length >= SIZE;
      btn.disabled = full || !v || !v.a;
      btn.classList.toggle('is-full', full);
      txt.textContent = !v || !v.a ? 'Sold out' : full ? 'Bundle is full' : 'Add to bundle';
      var n = slots.filter(function (s) { return s.block === card.data.block; }).length;
      var cnt = $('[data-ddb-count]', card.el);
      cnt.hidden = n === 0;
      cnt.textContent = n === 0 ? '' : (n > 1 ? n + ' in your bundle' : 'In your bundle');
      card.el.classList.toggle('is-picked', n > 0);
    }

    function addFromCard(card) {
      // ignore accidental double-taps
      var now = Date.now();
      if (card.lastAdd && now - card.lastAdd < 700) return;
      card.lastAdd = now;
      if (slots.length >= SIZE) { toast('Your bundle is full. Remove one to swap.'); return; }
      var v = currentVariant(card);
      if (!v || !v.a) return;
      slots.push({
        id: v.id, block: card.data.block, name: card.data.label,
        color: labelFor(card.colorBtns, v.c), length: labelFor(card.lenBtns, v.l),
        price: v.p, thumb: v.thumb
      });
      var btn = $('[data-ddb-add]', card.el);
      btn.classList.add('is-added');
      setTimeout(function () { btn.classList.remove('is-added'); }, 700);
      var left = SIZE - slots.length;
      toast(left > 0
        ? 'Added ' + card.data.label + '. Pick ' + left + ' more.'
        : 'All 3 picked! Tap "Add to cart" to finish.');
      save();
      renderAll();
      if (left === 0 && window.matchMedia('(min-width: 990px)').matches) {
        var cta = $('.ddb-panel [data-ddb-cta]');
        if (cta) cta.classList.add('is-ready');
      }
    }

    function removeSlot(i) {
      slots.splice(i, 1);
      save();
      renderAll();
    }

    /* ---------- panel + bar ---------- */
    var slotsEl = $('[data-ddb-slots]');
    var dotsEl = $('[data-ddb-bar-dots]');

    function renderAll() {
      var html = '';
      for (var i = 0; i < SIZE; i++) {
        var s = slots[i];
        if (s) {
          html += '<li class="ddb-slot is-filled">' +
            '<img src="' + esc(s.thumb) + '" alt="" width="64" height="64">' +
            '<div class="ddb-slot__txt"><b>' + esc(s.name) + '</b><span>' + esc(s.color) + ' &middot; ' + esc(s.length) + '</span></div>' +
            '<span class="ddb-slot__price">' + money(s.price) + '</span>' +
            '<button type="button" class="ddb-slot__x" data-ddb-remove="' + i + '" aria-label="Remove ' + esc(s.name) + '">Remove</button>' +
            '</li>';
        } else {
          html += '<li class="ddb-slot"><span class="ddb-slot__n">' + (i + 1) + '</span>' +
            '<div class="ddb-slot__txt"><b>Chain ' + (i + 1) + '</b><span>Not picked yet</span></div></li>';
        }
      }
      slotsEl.innerHTML = html;
      $$('[data-ddb-remove]', slotsEl).forEach(function (b) {
        b.addEventListener('click', function () { removeSlot(parseInt(b.dataset.ddbRemove, 10)); });
      });

      var dots = '';
      for (var j = 0; j < SIZE; j++) {
        dots += slots[j]
          ? '<span class="ddb-dot is-filled"><img src="' + esc(slots[j].thumb) + '" alt=""></span>'
          : '<span class="ddb-dot">' + (j + 1) + '</span>';
      }
      dotsEl.innerHTML = dots;

      var n = slots.length;
      var normal = slots.reduce(function (a, s) { return a + s.price; }, 0);
      $('[data-ddb-progress]').textContent = n + ' of ' + SIZE;
      $('[data-ddb-meter]').style.width = (n / SIZE * 100) + '%';
      $('[data-ddb-normal]').textContent = money(normal);
      $('[data-ddb-normal-row]').hidden = n === 0;
      var saveEl = $('[data-ddb-save]');
      saveEl.hidden = n < SIZE || normal <= price;
      $('[data-ddb-save-amt]').textContent = money(Math.max(0, normal - price));
      $('[data-ddb-bar-count]').textContent = n + ' of ' + SIZE;
      $('[data-ddb-bar-sub]').textContent = n === SIZE ? 'Save ' + money(Math.max(0, normal - price)) : 'picked';

      var ready = n === SIZE;
      $$('[data-ddb-cta]').forEach(function (b) {
        b.disabled = !ready;
        $('[data-ddb-cta-text]', b).textContent = ready
          ? 'Add to cart · ' + money(price)
          : 'Pick ' + (SIZE - n) + ' more chain' + (SIZE - n === 1 ? '' : 's');
        if (!ready) b.classList.remove('is-ready');
      });
      root.classList.toggle('is-ready', ready);
      var hint = $('[data-ddb-hint]');
      if (hint) hint.innerHTML = ready
        ? 'All 3 picked. <b>Add to cart</b> to get your $' + (price / 100) + ' price.'
        : 'Tap <b>Add to bundle</b> on any ' + (SIZE - n === SIZE ? SIZE : SIZE - n + ' more') + ' chain' + (SIZE - n === 1 ? '' : 's') + '.';
      Object.keys(cards).forEach(function (k) { updateAddBtn(cards[k]); });
    }

    /* ---------- persistence ---------- */
    function save() {
      try { localStorage.setItem(STORE_KEY, JSON.stringify(slots.map(function (s) { return s.id; }))); } catch (e) {}
    }
    function restore() {
      var ids = [];
      try { ids = JSON.parse(localStorage.getItem(STORE_KEY) || '[]') || []; } catch (e) { ids = []; }
      ids.slice(0, SIZE).forEach(function (id) {
        var hit = variantIndex[id];
        if (!hit || !hit.v.a) return;
        var c = hit.card;
        slots.push({
          id: id, block: c.data.block, name: c.data.label,
          color: labelFor(c.colorBtns, hit.v.c), length: labelFor(c.lenBtns, hit.v.l),
          price: hit.v.p, thumb: hit.v.thumb
        });
      });
    }

    /* ---------- checkout ---------- */
    var busy = false;
    function checkout(btn) {
      if (busy || slots.length < SIZE) return;
      busy = true;
      var errEl = $('[data-ddb-error]');
      errEl.hidden = true;
      $$('[data-ddb-cta]').forEach(function (b) { b.disabled = true; $('[data-ddb-cta-text]', b).textContent = 'Adding to cart…'; });
      var normal = slots.reduce(function (a, s) { return a + s.price; }, 0);
      var items = slots.map(function (s) {
        return { id: s.id, quantity: 1, properties: { _bundle: bundleName } };
      });
      var base = rootUrl.replace(/\/?$/, '/');
      var code = prefix && normal > price ? prefix + Math.round(normal / 100) : '';
      var drawer = document.querySelector('cart-drawer');
      var useDrawer = after === 'drawer' && drawer && typeof drawer.renderContents === 'function';
      var sections = useDrawer ? drawer.getSectionsToRender().map(function (x) { return x.id; }) : [];
      var post = function (url, body) {
        return fetch(base + url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) {
          return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; });
        });
      };

      post('cart/add.js', { items: items }).then(function () {
        try { localStorage.removeItem(STORE_KEY); } catch (e) {}

        if (!useDrawer) {
          var dest = after === 'checkout' ? '/checkout' : cartUrl;
          window.location.href = code
            ? base + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(dest)
            : dest;
          return;
        }

        // Apply the bundle code to the cart and get fresh drawer HTML in one call
        var body = { sections: sections, sections_url: window.location.pathname };
        if (code) body.discount = code;
        return post('cart/update.js', body).then(function (cart) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(cart);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'dd-bundle', cartData: cart });
          }
          busy = false;
          slots = [];
          renderAll();
        });
      }).catch(function (e) {
        busy = false;
        errEl.textContent = e.message + '. Please try again.';
        errEl.hidden = false;
        renderAll();
      });
    }
    $$('[data-ddb-cta]').forEach(function (b) { b.addEventListener('click', function () { checkout(b); }); });

    /* ---------- scroll helpers ---------- */
    $$('[data-ddb-scroll]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.getElementById('ddb-build');
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    var openBtn = $('[data-ddb-bar-open]');
    if (openBtn) openBtn.addEventListener('click', function () {
      var p = $('[data-ddb-panel]');
      if (p) p.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    // hide the mobile bar while the panel itself is on screen
    var bar = $('[data-ddb-bar]');
    var panel = $('[data-ddb-panel]');
    var build = document.getElementById('ddb-build');
    if (bar && 'IntersectionObserver' in window) {
      var panelVisible = false, buildSeen = false;
      var sync = function () { bar.classList.toggle('is-on', buildSeen && !panelVisible); };
      new IntersectionObserver(function (es) { panelVisible = es[0].isIntersecting; sync(); }, { threshold: 0.25 }).observe(panel);
      new IntersectionObserver(function (es) {
        if (es[0].isIntersecting || es[0].boundingClientRect.top < 0) buildSeen = true;
        sync();
      }).observe(build);
    } else if (bar) {
      bar.classList.add('is-on');
    }

    /* ---------- photo viewer ---------- */
    var lb = $('[data-ddb-lb]');
    var lbImg = lb && $('[data-ddb-lb-img]', lb);
    var lbThumbs = lb && $('[data-ddb-lb-thumbs]', lb);
    var lbAdd = lb && $('[data-ddb-lb-add]', lb);
    var lbCard = null, lbIdx = 0, lbPushed = false, lbOpener = null;

    function baseUrl(u) { return String(u || '').split('?')[0]; }

    function lbShow(i) {
      var imgs = lbCard.data.images;
      lbIdx = (i + imgs.length) % imgs.length;
      lbImg.src = imgs[lbIdx].src;
      lbImg.alt = lbCard.data.label + ', photo ' + (lbIdx + 1) + ' of ' + imgs.length;
      $('[data-ddb-lb-counter]', lb).textContent = imgs.length > 1 ? (lbIdx + 1) + ' of ' + imgs.length : '';
      $$('button', lbThumbs).forEach(function (b, j) { b.setAttribute('aria-current', j === lbIdx ? 'true' : 'false'); });
      var active = lbThumbs.children[lbIdx];
      if (active && active.scrollIntoView) active.scrollIntoView({ block: 'nearest', inline: 'center' });
    }

    function lbSyncAdd() {
      var v = currentVariant(lbCard);
      var full = slots.length >= SIZE;
      lbAdd.disabled = full || !v || !v.a;
      lbAdd.textContent = full ? 'Bundle is full'
        : (!v || !v.a) ? 'Sold out'
        : 'Add to bundle \u00b7 ' + labelFor(lbCard.colorBtns, lbCard.color) + (lbCard.length ? ' ' + labelFor(lbCard.lenBtns, lbCard.length) : '');
    }

    function openLb(card) {
      if (!lb || !card.data.images || !card.data.images.length) return;
      lbCard = card;
      lbOpener = document.activeElement;
      $('[data-ddb-lb-title]', lb).textContent = card.data.label;
      var imgs = card.data.images;
      lbThumbs.innerHTML = imgs.map(function (im, j) {
        return '<button type="button" aria-label="Photo ' + (j + 1) + '"><img src="' + esc(im.thumb) + '" alt="" width="64" height="64"></button>';
      }).join('');
      $$('button', lbThumbs).forEach(function (b, j) { b.addEventListener('click', function () { lbShow(j); }); });
      lbThumbs.hidden = imgs.length < 2;
      $$('[data-ddb-lb-prev],[data-ddb-lb-next]', lb).forEach(function (b) { b.hidden = imgs.length < 2; });
      // start on the photo of the color they have selected
      var v = currentVariant(card), start = 0;
      if (v) imgs.forEach(function (im, j) { if (baseUrl(im.src) === baseUrl(v.img)) start = j; });
      lbShow(start);
      lbSyncAdd();
      document.documentElement.classList.add('ddb-lb-open');
      if (lb.showModal) lb.showModal(); else lb.setAttribute('open', '');
      // phone back button closes the viewer instead of leaving the page
      try { history.pushState({ ddbLb: true }, ''); lbPushed = true; } catch (e) { lbPushed = false; }
      $('[data-ddb-lb-close]', lb).focus();
    }

    function closeLb() {
      if (!lb) return;
      if (lb.open) { if (lb.close) lb.close(); else lb.removeAttribute('open'); }
      onLbClosed();
    }
    function onLbClosed() {
      document.documentElement.classList.remove('ddb-lb-open');
      if (lbPushed) {
        lbPushed = false;
        if (history.state && history.state.ddbLb) history.back();
      }
      if (lbOpener && lbOpener.focus) { try { lbOpener.focus({ preventScroll: true }); } catch (e) {} }
    }

    if (lb) {
      $$('[data-ddb-lb-close]', lb).forEach(function (b) { b.addEventListener('click', closeLb); });
      $('[data-ddb-lb-prev]', lb).addEventListener('click', function () { lbShow(lbIdx - 1); });
      $('[data-ddb-lb-next]', lb).addEventListener('click', function () { lbShow(lbIdx + 1); });
      lbAdd.addEventListener('click', function () {
        var before = slots.length;
        addFromCard(lbCard);
        if (slots.length > before) closeLb();
      });
      // Esc key (native dialog) and any other close path
      lb.addEventListener('close', onLbClosed);
      lb.addEventListener('cancel', function () { /* Esc: let the dialog close */ });
      // tap on the dark area around the viewer (desktop) closes it
      lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
      document.addEventListener('keydown', function (e) {
        if (!lb.open) return;
        if (e.key === 'ArrowLeft') lbShow(lbIdx - 1);
        if (e.key === 'ArrowRight') lbShow(lbIdx + 1);
      });
      window.addEventListener('popstate', function () {
        if (lbPushed && lb.open) { lbPushed = false; closeLb(); }
      });
      // swipe left/right between photos
      var stage = $('[data-ddb-lb-stage]', lb), sx = null, sy = null;
      stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) lbShow(lbIdx + (dx < 0 ? 1 : -1));
        sx = sy = null;
      });
    }

    restore();
    renderAll();
  }

  function boot() { document.querySelectorAll('[data-ddb]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
